import React from 'react';

function Doller(props: object) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.30273 12.0672C7.30273 13.1535 8.13642 14.0293 9.17221 14.0293H11.2859C12.1869 14.0293 12.9196 13.263 12.9196 12.3199C12.9196 11.2925 12.4733 10.9304 11.808 10.6946L8.41431 9.51565C7.74905 9.27986 7.30273 8.91775 7.30273 7.89038C7.30273 6.94722 8.03537 6.18091 8.93642 6.18091H11.0501C12.0859 6.18091 12.9196 7.0567 12.9196 8.14301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1055 5.05249V15.1578"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1046 18.5262C14.7555 18.5262 18.5257 14.756 18.5257 10.1051C18.5257 5.45432 14.7555 1.68408 10.1046 1.68408C5.45383 1.68408 1.68359 5.45432 1.68359 10.1051C1.68359 14.756 5.45383 18.5262 10.1046 18.5262Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Doller;
